import type { ColDef } from '@/types/common.types';

export const FUND_COLS: ColDef[] = [
  { key: 'name',      labelKey: 'admin.colName',      locked: true },
  { key: 'questions', labelKey: 'admin.colQuestions'               },
  { key: 'status',    labelKey: 'admin.colStatus'                  },
  { key: 'audience',  labelKey: 'admin.colAudience'                },
  { key: 'createdBy', labelKey: 'admin.colCreatedBy'               },
  { key: 'feedback',  labelKey: 'admin.colFeedback'                },
  { key: 'period',    labelKey: 'admin.colPeriod'                  },
  { key: 'actions',   labelKey: 'admin.colActions',   locked: true },
];

export const PERS_COLS: ColDef[] = [
  { key: 'name',      labelKey: 'admin.colName',      locked: true },
  { key: 'createdBy', labelKey: 'admin.colCreatedBy'               },
  { key: 'status',    labelKey: 'admin.colStatus'                  },
  { key: 'audience',  labelKey: 'admin.colAudience'                },
  { key: 'questions', labelKey: 'admin.colQuestions'               },
  { key: 'feedback',  labelKey: 'admin.colFeedback'                },
  { key: 'period',    labelKey: 'admin.colPeriod'                  },
  { key: 'actions',   labelKey: 'admin.colActions',   locked: true },
];
